import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from 'react';
import { ToastContainer as ToastifyContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './ToastContainer.css';
const ToastContainerFC = () => {
    return (_jsx(ToastifyContainer, { stacked: true, position: 'bottom-right', hideProgressBar: true, style: { zIndex: 999 } }));
};
export const ToastContainer = memo(ToastContainerFC);
//# sourceMappingURL=ToastContainer.js.map